// frontend/src/components/AboutUsSection.js
import React, { useState } from 'react';
import { ChevronRightIcon } from './Icons';
import { getIconComponent, getColorClasses } from '../utils/iconMap';

const DEFAULT_VALUES = [
  {
    icon: 'Leaf',
    title: 'Naturverbundenheit',
    description: 'Wir erkunden die Wildnis, lernen die Natur zu schützen und verbringen unvergessliche Stunden unter freiem Himmel.',
    iconColor: 'primary',
  },
  {
    icon: 'Users',
    title: 'Gemeinschaft & Teamgeist',
    description: 'Gemeinsam meistern wir Herausforderungen, schließen Freundschaften fürs Leben und lernen, uns aufeinander zu verlassen.',
    iconColor: 'secondary',
  },
  {
    icon: 'Sparkles',
    title: 'Persönlichkeitsentwicklung',
    description: 'Wir fördern Selbstständigkeit, Verantwortungsbewusstsein und die Entwicklung neuer Fähigkeiten in jedem Pfadfinder.',
    iconColor: 'tertiary',
  },
  {
    icon: 'Globe',
    title: 'Unabhängigkeit & Offenheit',
    description: 'Wir sind nicht religiös oder parteipolitisch abhängig und für alle offen – jeder ist bei uns willkommen.',
    iconColor: 'primary',
  }
];

const AboutUsSection = ({ data }) => {
  const title = data?.title || 'Was Pfadfinden bei uns bedeutet';
  const subtitle = data?.subtitle || 'Unsere Werte und Ziele: Entdecke, was uns antreibt und wie wir gemeinsam wachsen.';
  const values = Array.isArray(data?.values) && data.values.length > 0 ? data.values : DEFAULT_VALUES;

  const [isOpen, setIsOpen] = useState(true);

  return (
    <section className="py-16 md:py-24 bg-surface-containerLow">
      <div className="container mx-auto px-6">
        <div className="flex justify-between items-end mb-12">
          <div className="space-y-2">
            <h2 className="text-headline-large md:text-display-small font-bold text-surface-on">
              {title}
            </h2>
            <p className="text-body-large text-surface-onVariant max-w-2xl">
              {subtitle}
            </p>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md3-btn-icon-unfilled w-12 h-12 flex items-center justify-center rounded-full bg-surface-containerHigh text-surface-on hover:bg-primary/10 hover:text-primary transition-all duration-300 shadow-elevation-1 cursor-pointer"
            aria-label={isOpen ? "Sektion einklappen" : "Sektion ausklappen"}
          >
            <ChevronRightIcon
              className={`transition-transform duration-300 ${isOpen ? 'rotate-90' : ''}`}
              sx={{ fontSize: 32 }}
            />
          </button>
        </div>

        <div className={`transition-all duration-500 ease-in-out overflow-hidden ${isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'}`}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 w-full pt-4">
            {values.map((value, index) => {
              const colorClasses = getColorClasses(value.iconColor);
              return (
                <div
                  key={index}
                  className="md3-card-outlined p-5 group hover:bg-surface-containerHigh transition-colors duration-medium2 ease-standard"
                >
                  {/* Icon Container */}
                  <div className={`w-12 h-12 rounded-lg flex items-center justify-center mb-4 ${colorClasses.bg}`}>
                    <div className={colorClasses.text}>
                      {getIconComponent(value.icon, { fontSize: 28 })}
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-title-medium font-semibold text-surface-on mb-2">
                    {value.title}
                  </h3>
                  <p className="text-body-medium text-surface-onVariant leading-relaxed">
                    {value.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;


